// Reference catalog transcribed from the client design mockup.
// Prices, stock, images, SKUs, and variant ids are replaced by the live catalog when it loads.
export const CATALOG = {
  "colors": {
    "sky": {
      "label": "Sky Blue",
      "hex": "#9CC9E6"
    },
    "white": {
      "label": "Coconut White",
      "hex": "#F4F1EA"
    },
    "matcha": {
      "label": "Matcha Mist",
      "hex": "#B9C6A7"
    },
    "midnight": {
      "label": "Midnight Blue",
      "hex": "#1F2E4D"
    }
  },
  "liners": {
    "bpMini": {
      "key": "bpMini",
      "name": "Birth Pool in a Box Pool Liner – Mini",
      "bcProductId": 2042,
      "bcVariantId": 5227,
      "sku": "1A92CFAB",
      "price": 60
    },
    "bpReg": {
      "key": "bpReg",
      "name": "Birth Pool in a Box Pool Liner – Regular",
      "bcProductId": 631,
      "bcVariantId": 5833,
      "sku": "1AE8D6CE",
      "price": 63
    },
    "es": {
      "key": "es",
      "name": "Earthside Birth Pool Liner",
      "bcProductId": 3927,
      "bcVariantId": 6084,
      "sku": "122123",
      "price": 55
    },
    "esU": {
      "key": "esU",
      "name": "Earthside Ultra Birth Pool Liner",
      "bcProductId": 4150,
      "bcVariantId": 6413,
      "sku": "120623",
      "price": 75
    },
    "lb": {
      "key": "lb",
      "name": "La Bassine Custom Birth Pool Liner",
      "bcProductId": 1313,
      "bcVariantId": 5891,
      "sku": "4385",
      "price": 48
    },
    "lbMaxi": {
      "key": "lbMaxi",
      "name": "La Bassine MAXI Liner",
      "bcProductId": 1884,
      "bcVariantId": 1852,
      "sku": "4970",
      "price": 53
    },
    "mvSerenity": {
      "key": "mvSerenity",
      "name": "Mia Via Serenity Birth Pool Liner",
      "bcProductId": 4070,
      "bcVariantId": 6307,
      "sku": "140223",
      "price": 52
    },
    "mvTranquility": {
      "key": "mvTranquility",
      "name": "Mia Via Tranquility Birth Pool Liner",
      "bcProductId": 3728,
      "bcVariantId": 4851,
      "sku": "130223",
      "price": 55
    },
    "oE": {
      "key": "oE",
      "name": "Oasis Elite Birth Pool Liner",
      "bcProductId": 3136,
      "bcVariantId": 4016,
      "sku": "112320",
      "price": 50
    },
    "oG": {
      "key": "oG",
      "name": "Oasis Elite GRAND Birth Pool Liner",
      "bcProductId": 3456,
      "bcVariantId": 4461,
      "sku": "142320",
      "price": 53
    },
    "oOv": {
      "key": "oOv",
      "name": "Oasis Oval Birth Pool Liner",
      "bcProductId": 3217,
      "bcVariantId": 4098,
      "sku": "1620",
      "price": 46
    },
    "oR": {
      "key": "oR",
      "name": "Oasis ROUND Birth Pool Liner",
      "bcProductId": 3396,
      "bcVariantId": 4392,
      "sku": "1621",
      "price": 46
    },
    "twO": {
      "key": "twO",
      "name": "Tubina Wild Milky Custom Liner – Original",
      "bcProductId": 4309,
      "bcVariantId": 6632,
      "sku": "131725",
      "price": 50
    },
    "twM": {
      "key": "twM",
      "name": "Tubina Wild Milky Custom Liner – Mini",
      "bcProductId": 4354,
      "bcVariantId": 6841,
      "sku": "130426",
      "price": 50
    },
    "universal": {
      "key": "universal",
      "name": "Universal Water Birth Pool Liner",
      "bcProductId": 1314,
      "bcVariantId": 6857,
      "sku": "BF382FFC",
      "price": 29.99
    }
  },
  "pools": [
    {
      "id": "bpiab-personal",
      "brand": "Birth Pool in a Box",
      "name": "Personal Pool",
      "short": "Birth Pool in a Box Personal Pool",
      "use": "personal",
      "mil": "0.38mm",
      "seat": "Built-in inflatable",
      "linerIncluded": true,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Custom form-fitted liner included",
        "3 stacked wall chambers: deflate the middle one to lower the height",
        "Inflatable floor, built-in seat, 6 handles",
        "Regular size leaves room for a partner"
      ],
      "sizes": [
        "Mini",
        "Regular"
      ],
      "colors": [
        "sky",
        "white",
        "matcha"
      ],
      "specs": {
        "Mini": {
          "ext": "65 × 57",
          "int": "45 × 37 × 26",
          "gal": 127
        },
        "Regular": {
          "ext": "76 × 65",
          "int": "56 × 45 × 26",
          "gal": 172
        }
      },
      "linerId": null,
      "linerBySize": {
        "Mini": "bpMini",
        "Regular": "bpReg"
      },
      "variants": [
        {
          "size": "Mini",
          "color": "sky",
          "bcProductId": 630,
          "bcVariantId": 3092,
          "sku": "BPM10",
          "price": 320,
          "fallbackOutOfStock": false
        },
        {
          "size": "Mini",
          "color": "white",
          "bcProductId": 4185,
          "bcVariantId": 6470,
          "sku": "BPM1W",
          "price": 320,
          "fallbackOutOfStock": false
        },
        {
          "size": "Mini",
          "color": "matcha",
          "bcProductId": 4379,
          "bcVariantId": 6899,
          "sku": "BPM1G",
          "price": 330,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "sky",
          "bcProductId": 3932,
          "bcVariantId": 6091,
          "sku": "BPR10",
          "price": 345,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "white",
          "bcProductId": 4184,
          "bcVariantId": 6469,
          "sku": "BPR1W",
          "price": 345,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "matcha",
          "bcProductId": 4380,
          "bcVariantId": 6900,
          "sku": "BPR1G",
          "price": 355,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "bpiab-pro2",
      "brand": "Birth Pool in a Box",
      "name": "Professional Pool 2.0",
      "short": "Professional Pool 2.0",
      "use": "pro",
      "mil": "0.55mm",
      "seat": "Built-in, 2 in. larger",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Heavy-duty 0.55mm PVC built for repeated births",
        "New screw-in floor valves, pump adapter included",
        "Insulated carrying case with backpack straps"
      ],
      "sizes": [
        "Mini",
        "Regular"
      ],
      "colors": [
        "midnight",
        "white"
      ],
      "specs": {
        "Mini": {
          "ext": "65 × 57",
          "int": "45 × 37 × 26",
          "gal": 127
        },
        "Regular": {
          "ext": "76 × 65",
          "int": "56 × 45 × 26",
          "gal": 172
        }
      },
      "linerId": null,
      "linerBySize": {
        "Mini": "bpMini",
        "Regular": "bpReg"
      },
      "variants": [
        {
          "size": "Mini",
          "color": "midnight",
          "bcProductId": 4231,
          "bcVariantId": 6652,
          "sku": "BHM2M",
          "price": 460,
          "fallbackOutOfStock": false
        },
        {
          "size": "Mini",
          "color": "white",
          "bcProductId": 4231,
          "bcVariantId": 6653,
          "sku": "BHM2W",
          "price": 460,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "midnight",
          "bcProductId": 4230,
          "bcVariantId": 6654,
          "sku": "BHR2M",
          "price": 500,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "white",
          "bcProductId": 4230,
          "bcVariantId": 6655,
          "sku": "BHR2W",
          "price": 500,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "bpiab-orig-pro",
      "brand": "Birth Pool in a Box",
      "name": "Original Professional Pool",
      "short": "Original Professional Pool",
      "use": "pro",
      "mil": "0.55mm",
      "seat": "Built-in inflatable",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Warrantied for 40 uses / 4 years",
        "Thicker padded bottom",
        "Insulated carrying case; limited availability"
      ],
      "sizes": [
        "Mini",
        "Regular"
      ],
      "colors": [
        "sky"
      ],
      "specs": {
        "Mini": {
          "ext": "65 × 57",
          "int": "45 × 37 × 26",
          "gal": 127
        },
        "Regular": {
          "ext": "76 × 65",
          "int": "56 × 45 × 26",
          "gal": 172
        }
      },
      "linerId": null,
      "linerBySize": {
        "Mini": "bpMini",
        "Regular": "bpReg"
      },
      "variants": [
        {
          "size": "Mini",
          "color": "sky",
          "bcProductId": 1819,
          "bcVariantId": 5402,
          "sku": "BHM00",
          "price": 395,
          "fallbackOutOfStock": false
        },
        {
          "size": "Regular",
          "color": "sky",
          "bcProductId": 1819,
          "bcVariantId": 5403,
          "sku": "BHR00",
          "price": 435,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "earthside-ultra",
      "brand": "Earthside",
      "name": "White Aesthetic Ultra Birth Pool",
      "short": "Earthside Ultra",
      "use": "personal",
      "mil": "0.5mm",
      "seat": "Integrated + cup holder",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": true,
      "features": [
        "Room for two, a favorite with taller mamas",
        "Integrated seat, cup holder and strong handles",
        "Pump and hose not included"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "76 × 64.5 × 27",
          "int": "—",
          "gal": 160
        }
      },
      "linerId": "esU",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 4149,
          "bcVariantId": 6412,
          "sku": "120523",
          "price": 349,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "earthside",
      "brand": "Earthside",
      "name": "White Aesthetic Birth Pool",
      "short": "Earthside pool",
      "use": "personal",
      "mil": "0.5mm",
      "seat": "Inflatable + cup holder",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Smaller footprint suits any room",
        "Inflatable seat and cup holder",
        "Phthalate-free eco PVC"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "65.5 × 59 × 27",
          "int": "—",
          "gal": 127
        }
      },
      "linerId": "es",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3912,
          "bcVariantId": 6061,
          "sku": "120123",
          "price": 279.99,
          "fallbackOutOfStock": true
        }
      ]
    },
    {
      "id": "la-bassine",
      "brand": "La Bassine",
      "name": "Birth Pool",
      "short": "La Bassine",
      "use": "personal",
      "mil": "0.45mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Cocoon shape in deep blue for privacy",
        "3 in. inflated floor, 2 internal handles",
        "Storage bag and repair kit included",
        "Ships direct from the maker in 3–10 days"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "65 × 53 × 30",
          "int": "50 × 38 × 26",
          "gal": 118
        }
      },
      "linerId": "lb",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 1312,
          "bcVariantId": 1819,
          "sku": "F8A4598C",
          "price": 225,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "la-bassine-pro",
      "brand": "La Bassine",
      "name": "Professional Birth Pool",
      "short": "La Bassine Professional",
      "use": "pro",
      "mil": "0.60mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "0.60mm vinyl, 30% stronger than the original",
        "Carrying case, repair kit and cover included",
        "Made for midwives and birth centers"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "65 × 53 × 28",
          "int": "50 × 38 × 26",
          "gal": 118
        }
      },
      "linerId": "lb",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 1855,
          "bcVariantId": 1841,
          "sku": "4810",
          "price": 330,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "la-bassine-maxi",
      "brand": "La Bassine",
      "name": "Maxi Birth Pool",
      "short": "La Bassine Maxi",
      "use": "personal",
      "mil": "0.45mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": true,
      "features": [
        "Same size class as Birth Pool in a Box Regular",
        "3 air chambers, 6 handles, 3 in. floor",
        "Cover included; ships direct in 3–10 days"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "75 × 65 × 28",
          "int": "57 × 46 × 25",
          "gal": 165
        }
      },
      "linerId": "lbMaxi",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 1857,
          "bcVariantId": 1842,
          "sku": "4820",
          "price": 265,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "la-bassine-maxi-pro",
      "brand": "La Bassine",
      "name": "Maxi Professional Birth Pool",
      "short": "La Bassine Maxi Pro",
      "use": "pro",
      "mil": "0.45mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": true,
      "features": [
        "Built for repeated professional use",
        "3 chambers, 6 handles, 3 in. floor",
        "Cover included; ships direct in 3–10 days"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "75 × 65 × 28",
          "int": "57 × 46 × 25",
          "gal": 165
        }
      },
      "linerId": "lbMaxi",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 1858,
          "bcVariantId": 1843,
          "sku": "4825",
          "price": 360,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "mia-via-tranquility",
      "brand": "Mia Via",
      "name": "Tranquility Water Birth Pool",
      "short": "Mia Via Tranquility",
      "use": "personal",
      "mil": "0.55mm",
      "seat": "Large 29 × 15 in.",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": true,
      "features": [
        "Large inflatable seat, kidney shape",
        "Lower the height by partly deflating the bottom ring",
        "Carrying bag included; free shipping"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "68 × 58 × 29.5",
          "int": "52 × 43 × 27.5",
          "gal": 166
        }
      },
      "linerId": "mvTranquility",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3726,
          "bcVariantId": 4849,
          "sku": "130123",
          "price": 255,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "mia-via-serenity",
      "brand": "Mia Via",
      "name": "Serenity Water Birth Pool",
      "short": "Mia Via Serenity",
      "use": "personal",
      "mil": "0.55mm",
      "seat": "Inner seat",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "26% smaller than the Tranquility",
        "Inner seat; 2 in. comfort floor; 4 handles",
        "Carrying bag included; free shipping"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "60 × 51 × 28",
          "int": "—",
          "gal": 126
        }
      },
      "linerId": "mvSerenity",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 4071,
          "bcVariantId": 6308,
          "sku": "140123",
          "price": 230,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "oasis-elite-grand",
      "brand": "Oasis",
      "name": "Elite GRAND Water Birth Pool",
      "short": "Oasis Elite GRAND",
      "use": "personal",
      "mil": "0.46mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": true,
      "features": [
        "32% more water than the Elite",
        "3 in. anti-slip Comfort-Cushion floor",
        "S-Beam walls; backpack carry bag"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "75 × 67 × 28",
          "int": "—",
          "gal": 160
        }
      },
      "linerId": "oG",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3455,
          "bcVariantId": 4460,
          "sku": "132220",
          "price": 230,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "oasis-elite",
      "brand": "Oasis",
      "name": "Elite Water Birth Pool",
      "short": "Oasis Elite",
      "use": "personal",
      "mil": "0.46mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "3 in. anti-slip Comfort-Cushion floor",
        "S-Beam opaque walls, screw valves",
        "Backpack carry bag; free UPS Ground"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "66 × 54 × 28",
          "int": "—",
          "gal": 115
        }
      },
      "linerId": "oE",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3135,
          "bcVariantId": 4015,
          "sku": "112220",
          "price": 210,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "oasis-oval",
      "brand": "Oasis",
      "name": "Oval Water Birth Pool",
      "short": "Oasis Oval",
      "use": "personal",
      "mil": "0.38mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Our most affordable pool",
        "3 in. anti-slip floor with printed fill lines",
        "Screw valves"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "64 × 50 × 22",
          "int": "—",
          "gal": 110
        }
      },
      "linerId": "oOv",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3009,
          "bcVariantId": 3894,
          "sku": "5032019",
          "price": 180,
          "fallbackOutOfStock": false
        }
      ]
    },
    {
      "id": "oasis-round",
      "brand": "Oasis",
      "name": "ROUND Water Birth Pool",
      "short": "Oasis Round",
      "use": "personal",
      "mil": "0.38mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": false,
      "roomy": false,
      "features": [
        "Round shape with 8 in. air walls",
        "3 in. anti-slip floor with fill lines",
        "Screw valves"
      ],
      "sizes": null,
      "colors": null,
      "specs": {
        "One": {
          "ext": "60 round × 24",
          "int": "—",
          "gal": 110
        }
      },
      "linerId": "oR",
      "linerBySize": null,
      "variants": [
        {
          "size": null,
          "color": null,
          "bcProductId": 3395,
          "bcVariantId": 4391,
          "sku": "15032021",
          "price": 180,
          "fallbackOutOfStock": true
        }
      ]
    },
    {
      "id": "tubina-wild",
      "brand": "Tubina Wild",
      "name": "Milky Birth Tub",
      "short": "Tubina Wild Milky Tub",
      "use": "personal",
      "mil": "0.4mm",
      "seat": "—",
      "linerIncluded": false,
      "genericLiner": false,
      "noUniversal": true,
      "roomy": false,
      "features": [
        "Arch shape: the straight side sits flush to a wall",
        "Inflatable bubble bottom, 3 tiers",
        "Mini is about 27% smaller inside for tight rooms"
      ],
      "sizes": [
        "Original",
        "Mini"
      ],
      "colors": null,
      "specs": {
        "Original": {
          "ext": "67 × 60 × 27",
          "int": "—",
          "gal": null
        },
        "Mini": {
          "ext": "59 × 51 × 25.5",
          "int": "41 × 33 × 25.5",
          "gal": 76
        }
      },
      "linerId": null,
      "linerBySize": {
        "Original": "twO",
        "Mini": "twM"
      },
      "variants": [
        {
          "size": "Original",
          "color": null,
          "bcProductId": 4183,
          "bcVariantId": 6468,
          "sku": "1005",
          "price": 224.99,
          "fallbackOutOfStock": false
        },
        {
          "size": "Mini",
          "color": null,
          "bcProductId": 4355,
          "bcVariantId": 6842,
          "sku": "130326",
          "price": 235.99,
          "fallbackOutOfStock": false
        }
      ]
    }
  ],
  "accessories": [
    {
      "group": "Filling & draining",
      "items": [
        {
          "id": "hose",
          "name": "Drinking Water Grade Hose",
          "desc": "Lead-safe hose for filling the pool.",
          "options": [
            {
              "key": "25",
              "label": "25'",
              "bcProductId": 3915,
              "bcVariantId": 6065,
              "sku": "120723",
              "price": 24.99
            },
            {
              "key": "50",
              "label": "50'",
              "bcProductId": 3915,
              "bcVariantId": 6066,
              "sku": "120823",
              "price": 39.99
            }
          ]
        },
        {
          "id": "adapter",
          "name": "Shower Pipe to Hose Adapter",
          "desc": "Connects a hose to a 1/2 in. shower pipe.",
          "bcProductId": 1956,
          "bcVariantId": 1876,
          "sku": "5325",
          "price": 6.25
        },
        {
          "id": "drain",
          "name": "Submersible Drain Pump",
          "desc": "Empties a pool in about 9–27 minutes.",
          "options": [
            {
              "key": "no",
              "label": "Pump only",
              "bcProductId": 1861,
              "bcVariantId": 5856,
              "sku": "82574E59",
              "price": 19.99
            },
            {
              "key": "yes",
              "label": "With vinyl hose",
              "bcProductId": 1861,
              "bcVariantId": 5859,
              "sku": "B8573843",
              "price": 27.99
            }
          ]
        },
        {
          "id": "airpump",
          "name": "Electric Air Pump",
          "desc": "Inflates and deflates; 3 nozzle sizes.",
          "bcProductId": 1860,
          "bcVariantId": 1845,
          "sku": "4835",
          "price": 19.99
        }
      ]
    },
    {
      "group": "In the water",
      "items": [
        {
          "id": "thermo",
          "name": "Floating Pool Thermometer",
          "desc": "Reads °F and °C; styles vary.",
          "bcProductId": 1318,
          "bcVariantId": 3226,
          "sku": "4405",
          "price": 12
        },
        {
          "id": "net",
          "name": "Water Birth Net",
          "desc": "Mesh net for lifting debris from the water.",
          "bcProductId": 1310,
          "bcVariantId": 5197,
          "sku": "4370",
          "price": 1.99
        },
        {
          "id": "flash",
          "name": "LED Underwater Flashlight",
          "desc": "Waterproof 180-lumen light; batteries included.",
          "bcProductId": 1900,
          "bcVariantId": 1857,
          "sku": "5040",
          "price": 21.99
        },
        {
          "id": "mirrorA",
          "name": "Angled Acrylic Birth Mirror",
          "desc": "7 in. angled mirror with handle.",
          "bcProductId": 2784,
          "bcVariantId": 3598,
          "sku": "132117",
          "price": 19.5
        },
        {
          "id": "mirrorO",
          "name": "Smooth Oval Acrylic Mirror",
          "desc": "Shatter-resistant handheld mirror.",
          "bcProductId": 3137,
          "bcVariantId": 4024,
          "sku": "112420",
          "price": 12.99
        },
        {
          "id": "gloveS",
          "name": "Water Birth Gloves, Sterile",
          "desc": "Shoulder-length, one size. Sold each.",
          "bcProductId": 831,
          "bcVariantId": 1685,
          "sku": "2200",
          "price": 1.99
        },
        {
          "id": "gloveN",
          "name": "Water Birth Glove, Non-Sterile",
          "desc": "Latex-free, shoulder-length. Sold each.",
          "bcProductId": 830,
          "bcVariantId": 1684,
          "sku": "2195",
          "price": 0.55
        }
      ]
    },
    {
      "group": "Floor, room & care",
      "items": [
        {
          "id": "floorP",
          "name": "Plastic Floor Covering, 9' × 12'",
          "desc": "Quiet 2 mil plastic to protect flooring.",
          "bcProductId": 1052,
          "bcVariantId": 1745,
          "sku": "3140",
          "price": 5.5
        },
        {
          "id": "floorV",
          "name": "Vinyl Floor Cover, 52 in.",
          "desc": "Wipe-clean, flannel-backed, beside the tub.",
          "bcProductId": 3306,
          "bcVariantId": 4268,
          "sku": "2321",
          "price": 6.99
        },
        {
          "id": "floorE",
          "name": "Earthside Floor Cover",
          "desc": "Oval 8.3 × 9 ft cover, under or over the pool.",
          "bcProductId": 3913,
          "bcVariantId": 6062,
          "sku": "120223",
          "price": 25.49
        },
        {
          "id": "lights",
          "name": "Warm White LED Fairy Lights",
          "desc": "16 ft with timer. Place between liner and pool.",
          "bcProductId": 4005,
          "bcVariantId": 6209,
          "sku": "131224",
          "price": 7.99
        },
        {
          "id": "coverMini",
          "name": "Birth Pool in a Box Cover – Mini",
          "desc": "Fits Mini pools; slows evaporation.",
          "bcProductId": 1872,
          "bcVariantId": 3247,
          "sku": "4895",
          "price": 24
        },
        {
          "id": "repair",
          "name": "Birth Pool in a Box Repair Kit",
          "desc": "Caps, patches, glue and spare valve parts.",
          "bcProductId": 2642,
          "bcVariantId": 1612,
          "sku": "22516",
          "price": 4.4
        },
        {
          "id": "wipes",
          "name": "Clorox Disinfecting Wipes",
          "desc": "Canister of 85 wipes for cleanup.",
          "bcProductId": 2898,
          "bcVariantId": 3751,
          "sku": "133121",
          "price": 6.99
        }
      ]
    }
  ]
}
